const COVERAGE_DECISION_DICT = {
  confirmed: 'Coverage Confirmed',
  partial_coverage: 'Partial Coverage Confirmed',
  denied: 'Coverage Denied',
} as const;

export default COVERAGE_DECISION_DICT;
